module.exports = __webpack_public_path__ + "static/Brixton-Ramblers-Penny-Farthings-Mark-Masons-Hall-London-3c449375a9c79083041a7fd2c92ab4a9.jpg";